<template>
    <div>
        <div v-if="errors.length" class="alert alert-danger">
            <p v-for="error in errors">
                {{ error }}
            </p>
        </div>

        <div v-if="! badge">
            <qrcode-reader @decode="onDecode" @locate="onLocate" />
        </div>

        <pincode v-if="badge" @pincode-cancel="onCancel" @submit="onSubmit" ref="pinInput"/>
    </div>
</template>

<script>
    import QrCodeReader from 'vue-qrcode-reader'
    import PinCodeInput from './Login/PinCodeInput.vue'

    Vue.use(QrCodeReader);
    Vue.component('pincode', PinCodeInput);

    export default {
        props: {},
        methods: {
            onDecode(code) {
                if (code) {
                    this.badge = code
                }
            },
            onLocate(location) {
                console.debug(location)
            },
            onCancel() {
                this.badge = ''
            },
            onSubmit(pin) {
                // Attempt the login
                axios.post(window.location.href, {
                    pin_code: pin,
                    badge_secret: this.badge,
                }).then(response => {
                    // Redirect the user to the page we are given or refresh this one
                    let body = response.data
                    window.location.href = body.redirect || window.location.href
                }).catch(err => this.onError(err))
            },
            onError(err) {
                // On error, reset the pincode form
                this.errors = _.get(err, 'response.data.errors[""]', [])

                console.error(err.response)
                this.$refs.pinInput.onReset()
            },
            async onInit (promise) {
                // show loading indicator

                try {
                    await promise

                    // successfully initialized
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        // user denied camera access permisson
                    } else if (error.name === 'NotFoundError') {
                        // no suitable camera device installed
                    } else if (error.name === 'NotSupportedError') {
                        // page is not served over HTTPS (or localhost)
                    } else if (error.name === 'NotReadableError') {
                        // maybe camera is already in use
                    } else if (error.name === 'OverconstrainedError') {
                        // passed constraints don't match any camera. Did you requested the front camera although there is none?
                    } else {
                        // browser is probably lacking features (WebRTC, Canvas)
                    }
                } finally {
                    // hide loading indicator
                }
            }
        },
        data() {
            return {
                badge: null,
                pin: null,
                errors: []
            };
        }
    }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Login.vue